import { PodStatus } from '../../api/pods.types';
import styles from './PodStatusBadge.module.scss';

interface Props {
  type?: PodStatus,
  text?: string,
  size?: 'compact' | 'mini'
}

const PodStatusBadge = ({type, text, size}: Props) => {
  let typeClassName = '';
  let typeText = text;

  if (type === "ACTIVATED") {
    typeClassName = styles.active;
    typeText ??= 'Active';
  } else if (type === "DEACTIVATED") {
    typeClassName = styles.inactive;
    typeText ??= 'Inactive';
  } else {
    typeText ??= '';
  }

  return (
    <div className={`${styles.badge}${size === 'compact' ? ` ${styles.compact}` : ''}${size === 'mini' ? ` ${styles.mini}` : ''}${typeClassName ? ` ${typeClassName}` : ''}`}>
      {typeText}
    </div>
  )
}

export default PodStatusBadge;